<div class="form mx-auto d-flex align-items-start justify-content-start px-5 py-3">
  <div class="form-container w-100 p-3">
    <div class="logo-header d-flex align-items-center my-4">
      <img
        src="assets/images/logo_legatus_fundo_claro_1.png"
        alt="Legatus Growth Partner"
        title="Legatus Growth Partner"
        class="img-fluid" />
    </div>
    <div class="form__header my-3">
      <h2 class="form__header__title mb-4">{{ tk.Auth.FirstAccessLabel | t }}</h2>
      <p class="form__header__subtitle mb-3">
        {{ tk.Auth.DefinePasswordToAccess | t }}
      </p>
    </div>

    <!-- Company Information Section -->
    <div *ngIf="companyInfo" class="company-info-section mb-4 p-3">
      <div class="company-info-section__header d-flex align-items-center mb-2">
        <i class="pi pi-building me-2"></i>
        <h3 class="company-info-section__title mb-0">Empresa</h3>
      </div>
      <div class="company-info-section__content">
        <p class="company-info-section__name mb-1">
          <strong>{{ companyInfo.displayName }}</strong>
        </p>
        <p class="company-info-section__cnpj mb-0 text-muted">
          CNPJ: {{ companyInfo.cnpj | vaultMaskCnpj }}
        </p>
      </div>
    </div>

    <div class="form-body">
      <form *ngIf="createPasswordForm" [formGroup]="createPasswordForm" appAutoFormGroup>
        <div class="form-group">
          <!-- First Name -->
          <app-input
            [type]="'text'"
            [id]="'firstName'"
            [controlName]="createPasswordProps.firstName"
            [placeholder]="tk.User.FirstName | t"
            [label]="tk.User.Name | t"
            [required]="true"
            [disabled]="isLoadingUserData">
          </app-input>

          <!-- Last Name -->
          <app-input
            [type]="'text'"
            [id]="'surName'"
            [controlName]="createPasswordProps.surName"
            [placeholder]="tk.User.SecondName | t"
            [label]="tk.User.Lastname | t"
            [required]="true"
            [disabled]="isLoadingUserData">
          </app-input>

          <!-- Phone Number -->
          <app-input
            [type]="'useMask'"
            [id]="'phoneNumber'"
            [unmask]="true"
            [mask]="'+99 (99) 99999-9999'"
            [placeholder]="'+55 (11) 99999-9999'"
            [autoClear]="false"
            [controlName]="createPasswordProps.phoneNumber"
            [label]="tk.User.Phone | t"
            [required]="false"
            [disabled]="isLoadingUserData">
          </app-input>

          <!-- Email (Readonly) -->
          <app-input
            [type]="'email'"
            [id]="'email'"
            [controlName]="'email'"
            [placeholder]="tk.User.Email | t"
            [label]="tk.User.Email | t"
            [required]="false"
            [disabled]="true">
          </app-input>

          <app-input
            [type]="'password'"
            [id]="'password'"
            [controlName]="createPasswordProps.password"
            [placeholder]="tk.General.Insert | t"
            [label]="tk.Auth.FieldPassword | t"
            [required]="true"
            (sendInputStatus)="handleInputStatus($event)">
          </app-input>

          <div *ngIf="showPasswordVerification" class="password-validation d-flex flex-column">
            <div class="password-validation__item d-flex align-items-center mb-3">
              <span class="password-validation__item__icon">
                <i
                  class="pi pi-check"
                  [ngClass]="{
                    'text-muted': hasError(createPasswordProps.password, 'minimumLength'),
                  }"></i>
              </span>
              <p class="password-validation__label mb-0 ms-2">
                {{ tk.Auth.AtLeast8Characters | t }}
              </p>
            </div>

            <div class="password-validation__item d-flex align-items-center mb-3">
              <span class="password-validation__item__icon">
                <i
                  class="pi pi-check"
                  [ngClass]="{
                    'text-muted': hasError(createPasswordProps.password, 'containsUppercase'),
                  }"></i>
              </span>
              <p class="password-validation__label mb-0 ms-2">
                {{ tk.Auth.AtLeast1CapitalLetter | t }}
              </p>
            </div>

            <div class="password-validation__item d-flex align-items-center mb-3">
              <span class="password-validation__item__icon">
                <i
                  class="pi pi-check"
                  [ngClass]="{
                    'text-muted': hasError(createPasswordProps.password, 'containsNumber'),
                  }"></i>
              </span>
              <p class="password-validation__label mb-0 ms-2">
                {{ tk.Auth.AtLeast1Number | t }}
              </p>
            </div>

            <div class="password-validation__item d-flex align-items-center mb-3">
              <span class="password-validation__item__icon">
                <i
                  class="pi pi-check"
                  [ngClass]="{
                    'text-muted': hasError(createPasswordProps.password, 'containsSymbol'),
                  }"></i>
              </span>
              <p class="password-validation__label mb-0 ms-2">
                {{ tk.Auth.AtLeast1Symbol | t }}
              </p>
            </div>
          </div>

          <app-input
            [type]="'password'"
            [id]="'password-confirmation'"
            [controlName]="createPasswordProps.confirmPassword"
            [placeholder]="tk.General.Insert | t"
            [label]="tk.Auth.FieldPasswordConfirmation | t"
            [required]="true"></app-input>
        </div>

        <!-- Aceite dos termos (card 2916). O texto vem do backend: é a `version` dele que
             fica gravada no aceite, então ele precisa ser a mesma coisa nos dois lados.
             Parceiro comercial recebe termos próprios; os demais, os gerais. -->
        <div *ngIf="terms" class="terms mt-4">
          <h3 class="terms__title mb-2">{{ terms.title }}</h3>

          <!-- Enquanto o documento jurídico não existir, dizer isso na cara da pessoa é o
               mínimo: ela está aceitando um texto preliminar, e esconder o rascunho faria
               a tela pedir aceite de algo que ninguém redigiu. -->
          <div *ngIf="terms.isPlaceholder" class="terms__placeholder mb-2">
            <i class="pi pi-exclamation-triangle me-2"></i>
            Texto preliminar — a versão definitiva substituirá esta e exigirá um novo aceite.
          </div>

          <!-- `innerHTML` porque o corpo é HTML montado pelo backend (parágrafos e listas),
               e não texto corrido. O conteúdo é nosso, vem de constante no servidor e não
               passa por entrada de usuário em nenhum ponto. -->
          <div class="terms__content" [innerHTML]="terms.content"></div>

          <app-checkbox
            [checkbox]="acceptTermsCheckbox"
            [formGroup]="createPasswordForm"
            [controlName]="'acceptTerms'"></app-checkbox>
        </div>

        <div class="form-group mt-4">
          <app-button
            [type]="'submit'"
            [id]="'submit'"
            [label]="isLoading ? loadingMessage : (tk.Auth.SiginButton | t)"
            [disabled]="isLoading || isLoadingUserData || !createPasswordForm.valid"
            (sendButtonClick)="onSubmit()"></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
